// extracted by mini-css-extract-plugin
export default {"Sthirteenth":"Sthirteenth_Sthirteenth__sXWCY","wrap":"Sthirteenth_wrap__NxXko","text":"Sthirteenth_text__6UFob","title":"Sthirteenth_title__ilDH4","desc":"Sthirteenth_desc__Aqskr"};